export var ShowOnDeviceOptions;
(function (ShowOnDeviceOptions) {
    ShowOnDeviceOptions[ShowOnDeviceOptions["AllDevices"] = 0] = "AllDevices";
    ShowOnDeviceOptions[ShowOnDeviceOptions["DesktopLaptop"] = 1] = "DesktopLaptop";
    ShowOnDeviceOptions[ShowOnDeviceOptions["SmartphoneTablet"] = 2] = "SmartphoneTablet";
})(ShowOnDeviceOptions || (ShowOnDeviceOptions = {}));
export const checkShowOnDevice = (showOnDeviceSetting = ShowOnDeviceOptions.AllDevices, isMobileOS) => {
    if (typeof isMobileOS === "undefined") {
        return true;
    }
    if (isMobileOS) {
        return [
            ShowOnDeviceOptions.SmartphoneTablet,
            ShowOnDeviceOptions.AllDevices,
        ].includes(showOnDeviceSetting);
    }
    return [
        ShowOnDeviceOptions.DesktopLaptop,
        ShowOnDeviceOptions.AllDevices,
    ].includes(showOnDeviceSetting);
};
